export const ModuleIdMappingProd = {
  PUBLIC_MODULE_ID: 'PUBLIC_MODULE_ID',
  SITE_MODULE: '52e0c3b6-0dc7-47d8-852d-1218770f85d7',
  SITE_MANAGEMENT: '813c3d8e-b387-4ee1-8672-6b4a89dd7d5f',
  SHIFT_MANAGEMENT: 'b4e92df2-b4f7-4bd4-ab58-ef223822d144',
  ROSTER_MANAGEMENT: '7019051f-4c48-4345-a964-6a8196ff12ee',
  AREA_MANAGEMENT: 'e27cd3bd-517d-4b17-adab-2e0478591d22',
  LEAVES: '95f92621-803f-4363-a57f-e2f4dc1d2b2c',
  HOLIDAY_CONFIGURATIONS: 'e8c5f83d-e3de-42c7-bb24-1e8fa2a64229',
  LEAVE_CONFIGURATIONS: '606c6b56-0373-415b-b403-e6133c6c1166',
  SEPARATION: '286bd474-d15c-4eeb-9762-346364c8e425',
  SEPARATION_OPEN_REQUESTS: '',
  SEPARATION_CLOSED_REQUESTS: '',
  SEPARATION_HISTORY_OPEN_REQUESTS: '286bd474-d15c-4eeb-9762-346364c8e425',
  SEPARATION_HISTORY_CLOSED_REQUESTS: '286bd474-d15c-4eeb-9762-346364c8e425',
  APPROVAL: 'd4a2e051-8dc1-47ec-92c6-7558cc851269',
  APPROVAL_LEAVES: 'c59ad8bc-171b-407d-b77c-30e8a76c3cc5',
  APPROVAL_LEAVES_OPEN_REQUESTS: 'c59ad8bc-171b-407d-b77c-30e8a76c3cc5',
  APPROVAL_LEAVES_CLOSED_REQUESTS: 'c59ad8bc-171b-407d-b77c-30e8a76c3cc5',
  APPROVAL_SEPARATION: '3e6ab483-7ada-4ab7-8e84-077c501ab373',
  APPROVAL_SEPARATION_OPEN_REQUESTS: '3e6ab483-7ada-4ab7-8e84-077c501ab373',
  APPROVAL_SEPARATION_CLOSED_REQUESTS: '3e6ab483-7ada-4ab7-8e84-077c501ab373',
  OVERTIME_MODULE_ID: '8c980d39-0819-40a4-89c5-1f6fa8d06022',
  CREATE_OVERTIME_MODULE_ID: '1d811246-876c-478c-bf54-9425ce30032b',
  EDIT_EMPLOYEE: 'e6009ede-55ee-4cf9-a2c4-d17c8adab58e',
  ELLIGIBLE_EMPLOYEE: '6367c922-e8a1-4929-a06d-29a597672d96',
  REGULARIZATION: '909beaf2-9231-4a1e-a95c-ee6a92e6d5fd',
  BULK_REGULARIZATION: '53a32e5a-7dd8-42f6-a084-2fb047d9b892',
  BULK_USER_UPLOAD: 'c584c9e2-0885-42fa-8fea-e03729a57928',
  BULK_GRACE_ATTENDANCE: '8e458250-1903-45f1-85f7-5ee87a080ed5',
  BULK_ROLE_UPDATE: 'f81f54ce-9178-48b8-bc7c-48576503abc3',
  BULK_UPLOAD: 'cf720eab-6f71-4d04-96b5-7472768e49b7',
  ATTENDANCE_LOG: '7d6447f6-3115-4bcf-af07-f24e3d502a7b',
  PUNCH_IN_APPROVALS: 'c7c59d90-368b-4f45-8866-a99bccf2b471',
  PUNCH_OUT_APPROVALS: 'fc62f69b-f284-4b92-b1b5-d7467f59ce12',
  OT_TOP_UP: '08343701-febd-41d7-8f76-e86bb61bdc5d',
  SPOOF_APPROVAL: '7c58993f-dc88-491d-8d89-5c592b1e9746',
  PLANNED_OT_APPROVAL: '2def10c5-7246-4deb-a204-a941b94e7b3c',
  CANDIDATE_MODULE: '9a61d8d0-2fa2-4d7c-9f40-4a226b12ba11',
  JOB_REQUISITION_MODULE: '2bac520a-be0b-49a2-8c8f-c0ec37acb849',
  JOB_REQUISITION_CANDIDATE_MODULE: '7d343397-9456-4ad4-bfeb-5b79a6039b21',
  APPLICATION_STATUS_MODULE: '56600d0f-1e71-433b-9372-409db717b342',
  CANDIDATE_REVIEW_MODULE: '9a61d8d0-2fa2-4d7c-9f40-4a226b12ba11',
  CANDIDATE_PRE_ONBOARDING: '43dd5eb2-a147-496c-b22e-9abbc1171c60',
  APPROVAL_BGV: '562adfe4-a83f-4c56-9497-33ec5afde7a2',
  APPROVAL_BGV_OPEN_REQUESTS: '562adfe4-a83f-4c56-9497-33ec5afde7a2',
  APPROVAL_BGV_CLOSED_REQUESTS: '562adfe4-a83f-4c56-9497-33ec5afde7a2',
  REPORTS: 'c9554c30-4fa7-40d2-bd23-ceec19a6bf1f',
  UPLOAD_REPORTS_MODULE: 'c9554c30-4fa7-40d2-bd23-ceec19a6bf1f',
  DOWNLOAD_REPORTS_MODULE: 'c9554c30-4fa7-40d2-bd23-ceec19a6bf1f',
  ONBOARDING_TRACKER: 'a177d788-d1a0-4cd8-b540-51b52b398baa',
  TEAM_MANAGEMENT: 'ea6db965-dd39-4f86-a864-84d0fec67736',
  VENDORS: '4c5cabc0-2a2b-4504-aef4-2dc7fa675105',
  VENDORS_LIST: '4c5cabc0-2a2b-4504-aef4-2dc7fa675105',
  VENDOR_REPORT: 'e4fde5cf-9864-41ba-a920-24110d15c840',
  USER_MANAGEMENT: '649dfc7f-b991-4ebe-b92f-21bd4e426a98',
  USERS: '3966e291-1477-4ec3-b351-e57b55d1ddb9',
  ROLES: 'c9d55e6d-1bca-445d-85cb-cd7201d6ab6e',
  CONFIG: 'c786f95c-a5fa-497b-9d21-4627743ff78f',
  SITE_LEVEL_CONFIG: '147a1fcb-bb63-4cff-a8e1-5163f67efc08',
  ROLE_LEVEL_CONFIG: '2352ab45-4aec-447a-8eb1-a665f2451ff5',
  FLEX_MANAGEMENT: '34ed07bd-c5c1-41e1-9f8f-db49f3fba39c',
  FLEX_SLOT_MANAGEMENT: '60c58ab0-140f-4e1f-9f35-ff252854fcd2',
  FLEX_RATE_CARD_MANAGEMENT: '4e0ea5a1-8b1b-4c09-bd79-4b9e0d7e4660',
  FLEX_SITE_MANAGEMENT_DETAILS: '0fecc68b-2e8a-4d64-ba8a-295df845b7b9', //todo to remove
  FLEX_SITE_MANAGEMENT: 'e290ec13-e838-47fe-8dd1-81974be90d7c',
  FLEX_PAYOUT_MANAGEMENT: '295bc80a-c0a8-4137-a3bc-9c42691c34c4',
  GRIEVANCE_MANAGEMENT: '3f2cc438-11e9-4dd7-8f95-80cf37d213ff',
  GRIEVANCE_DETAIL: '3f2cc438-11e9-4dd7-8f95-80cf37d213ff', //TODO ONCE BACKEND CHANGE
  TRANSFER_MODULE: 'f8d391de-60e3-48c5-b732-70d6ccc6fd6c',
  TRANSFER_REQUESTS_TRACKER: 'f8d391de-60e3-48c5-b732-70d6ccc6fd6c',
  TRANSFER_REQUESTS_TRACKER_DETAILS: '0342252f-daea-4303-b11c-0ed9d05bec94',
  TRANSFER_EMPLOYEE_HISTORY: 'e4690b34-4e08-4f2b-9a59-679c770fbea9',
  APPROVAL_TRANSFERS: '50347cca-5fd7-4d40-8610-5c19a045507b',
  APPROVAL_TRANSFERS_OPEN_REQUESTS: '50347cca-5fd7-4d40-8610-5c19a045507b',
  APPROVAL_TRANSFERS_CLOSED_REQUESTS: '50347cca-5fd7-4d40-8610-5c19a045507b',
  PROFILE: 'PUBLIC_MODULE_ID',
  VENDOR_ONBOARDING: 'PUBLIC_MODULE_ID',
  SALARY_MAPPING: '73e0ce04-bae4-4d76-9347-698979e6cd11',
  PAYOUT_PROCESSING: '6a5ef52e-6dff-40d8-9b70-d4f436b09664',
  VENDOR_SALARY_PAYOUT: 'e8e23a3b-46f3-42f6-9d1f-98c88092db44',
  EDGE_PAYOUT_PROCESSING: 'a3266cb2-bd12-48b6-9f41-eae532de6541',
  VENDOR_PROCESSED_PAYOUT_VIEW: '3fc52f6f-fb4d-4cec-af05-dd4f43e28469',
  CREATE_BULK_USER_CREATION: '05ca8d1f-1e27-484f-9446-4789b33613a6',
  CREATE_BULK_USER_UPDATION: '26e50efd-cdc7-42fd-9d00-de970d7ac306',
  BLACKLISTED_EMPLOYEE: 'e4332b56-535e-4d4f-b553-72aa92e006f5',
  ROASTER_PLANNING: '35a62606-92a8-4b8a-b9fd-1cbf9c1e7929',
  BLACKLISTING_SEPERATION: 'ebdd55e4-6108-4288-b7d9-79acf225f0ef',
  APPROVAL_ABSCONDING: '54f12d42-df2b-431b-9ce2-8ed475f7be81',
  CREATE_INCENTIVE: '5af9c811-8126-4701-a232-5abb428a4b29',
  INCENTIVE_VIEW: '5af9c811-8126-4701-a232-5abb428a4b29',
  INCENTIVE_MANAGEMENT: '5af9c811-8126-4701-a232-5abb428a4b29',
  REFERRAL_RATE_CARD_MANAGEMENT: 'c884f06a-86b3-4518-8718-5d4c49b88ca6',

  ADDENDUM_MANAGEMENT: '63af0d5e-bf16-4445-85ff-321bd00ae527',

  FT_FLEX_MANAGEMENT: 'aefdb977-9392-447e-bfff-c0c828805b3a',
  FT_FLEX_SLOT_MANAGEMENT: '8898188a-03bd-40db-aa32-55e982c53f53',
  FT_FLEX_RATE_CARD_MANAGEMENT: '074a474d-08cc-4d26-82e9-f83e96fa280d',

  IT_APPROVALS: 'e898b3d8-d69d-4e28-b82a-6b677d797649',
  IT_APPROVALS_SEPARATION: 'e898b3d8-d69d-4e28-b82a-6b677d797649',
  IT_APPROVALS_EMPLOYEE_ASSET: 'fef438ca-6504-479c-a207-184434235b44',
  IT_APPROVALS_EMPLOYEE_ASSET_OPEN_REQUESTS:
    'fef438ca-6504-479c-a207-184434235b44',
  IT_APPROVALS_EMPLOYEE_ASSET_CLOSED_REQUESTS:
    'fef438ca-6504-479c-a207-184434235b44',
  APPROVAL_IT_REVIEW: 'e898b3d8-d69d-4e28-b82a-6b677d797649',
  APPROVAL_IT_REVIEW_OPEN_REQUESTS: 'e898b3d8-d69d-4e28-b82a-6b677d797649',
  APPROVAL_IT_REVIEW_CLOSED_REQUESTS: 'e898b3d8-d69d-4e28-b82a-6b677d797649',
  APPROVAL_POST_ONBOARDING: '5e58065e-c121-4408-b0db-c945835f7260',
};
